function ChatBubble({ text, sender }) {
  const isUser = sender === "user";

  return (
    <div
      className={`w-full flex ${isUser ? "justify-end" : "justify-start"} mb-2`}
    >
      <div
        className={`px-4 py-2 max-w-[70%] text-sm rounded-xl shadow-md ${
          isUser ? "text-gray-1200" : "text-gray-900"
        }`}
        style={{
          backgroundColor: isUser
            ? "rgba(34, 197, 94, 0.15)"   // green-600 @ 15% opacity
            : "rgba(255, 255, 255, 0.1)", // cyan @ 10% opacity
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
          border: isUser
            ? "1px solid rgba(0,0,0,0.05)"
            : "1px solid rgba(255,255,255,0.05)",
        }}
      >
        {text}
      </div>
    </div>
  );
}

export default ChatBubble;
